import React from "react";
import { useTranslation } from "react-i18next";
import { whiteLogo } from "../icons/white-logo";
import { whatsapp } from "../icons/whatsapp";
import { facebook } from "../icons/facebook";
import { Link } from "react-router-dom";
import LanguageSwitcher from "./LanguageSwitcher";

function Footer() {
  const { t } = useTranslation();

  return (
    <div className="w-full h-fit lg:h-[24rem]">
      <div className="bg-mobile-footer-background lg:bg-footer-background bg-cover bg-center h-full">
        <div className="text-white flex flex-col lg:flex-row py-10 lg:py-0 lg:justify-between lg:items-center h-full px-20">
          <div className="flex flex-col lg:flex-row gap-20 lg:gap-44 text-xl lg:text-2xl">
            <div className="lg:flex flex-col hidden gap-10">
              <span className="mx-auto">{whiteLogo}</span>© Copyright Acts
            </div>
            <div className="flex flex-col gap-2 text-center">
              <span className="text-lg text-gray-400">{t("footer.menu")}</span>
              <Link to={"/home/cropsOffers"}>
                <span>{t("common.crops")}</span>
              </Link>
              <Link to={"/home/services"}>
                <span>{t("common.services")}</span>
              </Link>
              <Link to={"/home/prices"}>
                <span>{t("common.prices")}</span>
              </Link>
              <Link to={"/home/weather"}>
                <span>{t("common.weather")}</span>
              </Link>
              <Link to={"/home/profile"}>
                <span>{t("common.profile")}</span>
              </Link>
            </div>
            <div className="flex flex-col gap-2 text-center">
              <Link to={"/home/about"}>
                <span>{t("common.about")}</span>
              </Link>
              <Link to={"/home/privacy-policy"}>
                <span>{t("footer.privacy")}</span>
              </Link>
              <Link to={"/home/terms"}>
                <span>{t("footer.terms")}</span>
              </Link>
            </div>
          </div>

          <div className="flex gap-3 flex-col items-center mt-20 lg:my-0 lg:items-end">
            <LanguageSwitcher />
            <p className="text-center text-2xl mt-4">{t("footer.contactUs")}</p>
            <a className="text-9xl hover:scale-110 transition-transform" href="tel:3623">
              3623
            </a>
            <div className="text-2xl">
              <button
                onClick={() => (window.location = "mailto:info@mahsool.sd")}
                className="hover:underline"
              >
                info@mahsool.sd
              </button>
            </div>
            <div className="flex gap-3 mt-2">
              <a href="https://wa.me/message/K5BD6QOI2BBYE1" target="_blank" rel="noopener noreferrer">
                <p className="p-3 bg-white/10 rounded-full hover:scale-110 hover:shadow-white hover:shadow-md transition-all">
                  {whatsapp}
                </p>
              </a>
              <a
                href="https://www.facebook.com/profile.php?id=100089265053519&mibwxtid=ZbWKwL"
                target="_blank"
                rel="noopener noreferrer"
              >
                <p className="p-3 bg-white/10 rounded-full hover:scale-110 hover:shadow-white hover:shadow-md transition-all">
                  {facebook}
                </p>
              </a>
            </div>
            <div className="flex flex-col mt-10 lg:hidden gap-10">
              <span className="mx-auto">{whiteLogo}</span>© Copyright Acts
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;